import { pdfjs } from 'react-pdf'
import PdfDocumentWrapper from '../../PdfDocumentWrapper'
import { FileDetails } from '../../../../shared/src/data/fileDetails'
import { useFetchFromServer } from '../../api/fetchHook'
import { serverRoutes } from '../../layout/serverRoutes'
import { useQuery } from 'react-query'
import { filesKeyFactory } from './filesKeyFactory'

export const useFiles = (files?: FileDetails[]) => {
  const { fetchJsonFromServer } = useFetchFromServer()
  return useQuery(
    filesKeyFactory.files(files),
    async () =>
      !files
        ? []
        : await Promise.all(
            files.map((f, i) =>
              fetchJsonFromServer<{ url: string }>(
                serverRoutes.api.scansMetadata.getFilePreSignedUrl(f.id),
              )
                .then(({ url }) =>
                  pdfjs.getDocument({ url, isEvalSupported: false }),
                )
                .then((doc) => doc.promise)
                .then((doc) => new PdfDocumentWrapper(f.id, f.name, doc)),
            ),
          ),
    {
      refetchInterval: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      staleTime: Infinity,
    },
  )
}
